import "../../../../index79.css";
import { jsx as t, jsxs as o, Fragment as a } from "react/jsx-runtime";
import { _ as n } from "../../../../cs-piwRuCFZ.js";
import "../../../../type-BFTbooL7.js";
import i from "../../../DateOutput/index.js";
import c from "../../HeaderCell/index.js";
const p = "_timeline-header_1sebe_1", _ = "_title_1sebe_2", r = {
  timelineHeader: p,
  title: _
};
function N(s) {
  const {
    className: l,
    dateRange: e,
    ...m
  } = s;
  return /* @__PURE__ */ t(
    c,
    {
      ...m,
      className: n(r.timelineHeader, l),
      titleClassName: r.title,
      title: /* @__PURE__ */ o(a, { children: [
        /* @__PURE__ */ t(
          i,
          {
            value: e == null ? void 0 : e.start
          }
        ),
        /* @__PURE__ */ t(
          i,
          {
            value: e == null ? void 0 : e.end
          }
        )
      ] })
    }
  );
}
export {
  N as default
};
